module.exports = {"menuoptions":[{"name":"mo1","ref":"/home"},{"name":"mo2","ref":"/lobby"},{"name":"mo3","ref":"/case-progress"},{"name":"mo4","ref":"/done"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/menuoptions.json
// module id = XFS4
// module chunks = 6